import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export function Checkmark({isGreen}: {isGreen: boolean}): JSX.Element {
  return (
    <BenchlingIcon
      icon="check"
      className={classNames('u-input-line-height checkmarkBullet-icon', {
        'checkmarkBullet-icon--green': isGreen,
        'checkmarkBullet-icon--blue': !isGreen,
      })}
    />
  );
}

Checkmark.propTypes = {
  isGreen: PropTypes.bool.isRequired,
};

interface CheckmarkBulletProps {
  className?: string;
  isGreen: boolean;
  text: string;
}

export default function CheckmarkBullet({className, isGreen, text}: CheckmarkBulletProps): JSX.Element {
  return (
    <Row className={classNames('checkmarkBullet', className)}>
      <Col xs={1}>
        <Checkmark isGreen={isGreen} />
      </Col>
      <Col xs={10} className="checkmarkBullet-text">
        {text}
      </Col>
    </Row>
  );
}
